import { Route, Routes } from "react-router";
import TapGrister from "../screens/TapGristster/TapGrister";
import Login from "../screens/Login/Login";
import ParentBinder from "../screens/Bind/ParentBinder";
import Email from "../screens/Email/Email";
import Dashboard from "./Dashboard";

export default function RoutesContainer() {
  return (
    <div className="main-container">
      <Routes>
        <Route path="/login" index element={<Login />} />
        <Route path="/parent_code/:parent_code" element={<TapGrister />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/connect" element={<ParentBinder />} />
        <Route path="/email" element={<Email />} />
        <Route path="*" element={<Login />} />
      </Routes>
    </div>
  );
}
